/**
 * Lalay Addresses API — wraps /wp-json/lalay/v1/addresses.
 * Same Bearer-token pattern as checkout.js / auth.js.
 */

import { getToken } from './auth';

const BASE = '/wp-json/lalay/v1';

async function call(path, opts = {}) {
  const headers = { 'Content-Type': 'application/json', ...(opts.headers || {}) };
  const tok = getToken();
  if (tok && !headers.Authorization) headers.Authorization = `Bearer ${tok}`;
  const res = await fetch(`${BASE}${path}`, { ...opts, headers });
  const text = await res.text();
  let body;
  try { body = text ? JSON.parse(text) : {}; } catch { body = { success: false }; }
  return { ok: res.ok, status: res.status, body };
}

export async function fetchAddresses() {
  const { status, body } = await call('/addresses');
  if (status === 200 && body.success) return body.addresses || [];
  return [];
}

export async function createAddress(payload) {
  const { status, body } = await call('/addresses', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  if (status === 200 && body.success) return { address: body.address };
  return { error: body.message || 'Could not save address', code: body.code, status };
}

export async function updateAddress(id, payload) {
  const { status, body } = await call('/addresses/' + Number(id), {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
  if (status === 200 && body.success) return { address: body.address };
  return { error: body.message || 'Could not update address', code: body.code, status };
}

export async function deleteAddress(id) {
  const { status, body } = await call('/addresses/' + Number(id), {
    method: 'DELETE',
  });
  if (status === 200 && body.success) return { ok: true };
  return { error: body.message || 'Could not delete address', code: body.code, status };
}

export async function setDefaultAddress(id) {
  const { status, body } = await call('/addresses/' + Number(id) + '/default', {
    method: 'POST',
  });
  if (status === 200 && body.success) return { ok: true };
  return { error: body.message || 'Could not set default', code: body.code, status };
}
